package pl.decks.personal.components.widgets.ranks

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier

interface Rank {
    val slot: Slot
    val title: String

    @Composable
    fun render() = render(Modifier)
    @Composable
    fun render(modifier: Modifier)

    enum class Slot { S1, S2, S3, S4, S5, S6, S7, S8, S9; }
}
